function applyAspectRatio(iframe: HTMLIFrameElement) {
  const w = Number(iframe.getAttribute('width'));
  const h = Number(iframe.getAttribute('height'));
  if (w > 0 && h > 0) {
    iframe.style.aspectRatio = `${w} / ${h}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll<HTMLIFrameElement>('.fullwidth-video iframe')
    .forEach(applyAspectRatio);
});
